// extracted by mini-css-extract-plugin
export default {"card":"annD8F","external":"bnnD8F","selected":"cnnD8F"};